import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["tokens", "fullScreen", "fullScreenBottomOffset", "placement", "children", "customZIndex"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import { ModalOverlay } from './ModalOverlay';
import * as views from './Modal.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var Modal = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var tokens = _ref.tokens,
      fullScreen = _ref.fullScreen,
      fullScreenBottomOffset = _ref.fullScreenBottomOffset,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "top" : _ref$placement,
      children = _ref.children,
      customZIndex = _ref.customZIndex,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(ModalOverlay, {
    fullScreen: fullScreen,
    fullScreenBottomOffset: fullScreenBottomOffset,
    placement: placement,
    customZIndex: customZIndex,
    children: _jsx(views.Wrapper, _objectSpread(_objectSpread(_objectSpread({}, tokens), {}, {
      role: "dialog",
      elevation: 1,
      ref: ref,
      fullScreen: fullScreen
    }, rest), {}, {
      children: children
    }))
  });
});
var sizes = {
  small: 384,
  medium: 448,
  large: 512,
  xlarge: 576
};
export var ModalBase = withDesignTokens(Modal, function (_ref2) {
  var size = _ref2.size;
  return {
    maxWidth: sizes[size || "medium"]
  };
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      sectionSeparatorColor: theme.palette.brand.darkAcai[200]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[600],
      sectionSeparatorColor: theme.palette.brand.darkAcai[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      sectionSeparatorColor: theme.palette.twilio.gray[20]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      sectionSeparatorColor: theme.palette.twilio.gray[20]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      backgroundColor: theme.palette.cdpWeek2023.gray[90],
      sectionSeparatorColor: theme.palette.cdpWeek2023.gray[80]
    };
  }
});